export enum FilterAction {
    AttrFacetChanged = 'attrFacetChanged',
    AttrFacetRemoved = 'attrFacetRemoved',
    AuctionHouseChanged = 'auctionHouseChanged',
    AuctionHouseRemoved = 'auctionHouseRemoved',
    BuyingFormatChanged = 'buyingFormatChanged',
    BuyingFormatRemoved = 'buyingFormatRemoved',
    CategoryChanged = 'categoryChanged',
    CategoryRemoved = 'categoryRemoved',
    ClearAllFilters = 'clearAllFilters',
    CreatorChanged = 'creatorChanged',
    CreatorRemoved = 'creatorRemoved',
    CurrentBidChanged = 'currentBidChanged',
    CurrentBidRemoved = 'currentBidRemoved',
    FilterTermAdded = 'filterTermAdded',
    FilterTermRemoved = 'filterTermRemoved',
    HammerPriceChanged = 'hammerPriceChanged',
    HammerPriceRemoved = 'hammerPriceRemoved',
    HouseExcluded = 'houseExcluded',
    LocationChanged = 'locationChanged',
    LocationRemoved = 'locationRemoved',
    OriginChanged = 'originChanged',
    OriginRemoved = 'originRemoved',
    PageChanged = 'pageChanged',
    PageSizeChanged = 'pageSizeChanged',
    PriceRangeChanged = 'priceRangeChanged',
    PriceRangeRemoved = 'priceRangeRemoved',
    PublishDateChanged = 'publishDateChanged',
    PublishDateRemoved = 'publishDateRemoved',
    PublishedDateRemoved = 'publishedDateRemoved',
    RatingChanged = 'ratingChanged',
    RatingRemoved = 'ratingRemoved',
    SaleDateChanged = 'saleDateChanged',
    SaleDateRemoved = 'saleDateRemoved',
    ShippingChanged = 'shippingChanged',
    ShippingRemoved = 'shippingRemoved',
    MaterialsAndTechniquesChanged = 'materialsAndTechniquesChanged',
    MaterialsAndTechniquesRemoved = 'materialsAndTechniquesRemoved',
    SortByChanged = 'sortByChanged',
    StylePeriodChanged = 'stylePeriodChanged',
    StylePeriodRemoved = 'stylePeriodRemoved',
    ViewPriceResults = 'viewPriceResults',
    ViewUpcomingItems = 'viewUpcomingItems',
}

export type FacetValue = {
    count: number;
    name: string;
    qs?: string;
    selected: boolean;
    sequence: number;
    url?: string;
    value?: number | string;
};

export type FacetCurrency = string;

export type Facet = {
    countries?: FacetValue[];
    currencies?: FacetCurrency[];
    end_range?: number;
    id: string;
    name: string;
    qs: string;
    role: string;
    selected_country?: string;
    selected_end?: string;
    selected_postal_code?: string;
    selected_radius?: number;
    selected_radius_unit?: string;
    selected_start?: string;
    selected_value?: string;
    selection: string;
    sequence: number;
    start_range?: number;
    total_count: number;
    type: string;
    values?: FacetValue[];
};

export type ResultFacetCategories = {
    facets: ResultFacet[] | null;
};

export type ResultFacet = {
    categories?: ResultFacetCategories;
    count: number;
    id: string;
    name: string;
    options?: ResultFacet[] | null;
    parents?: ResultFacet[] | null;
    selected: boolean;
};
